const DESIGN_WIDTH = 390;
const ROOT_PX = 12;

export function setupRootFontSize() {
  const setRootFontSize = () => {
    const w =
      document.documentElement.clientWidth ||
      window.innerWidth ||
      DESIGN_WIDTH;
    document.documentElement.style.fontSize =
      (w / DESIGN_WIDTH) * ROOT_PX + 'px';
  };

  setRootFontSize();
  window.addEventListener('resize', setRootFontSize);
  window.addEventListener('orientationchange', setRootFontSize);
}
